import styled from 'styled-components';

export const Quote = styled.span`
  font-family: var(--font-secondary);
  font-size: 5.2rem;
  color: var(--color-secondary);
  white-space: nowrap;
  display: flex;
  align-items: center;

  &::before {
    content: '';
    width: 4rem;
    height: 0.5rem;
    background: var(--color-bg);
    margin: 0 1.5rem;
  }

  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: 12.5rem;

    &::before {
      width: 9.5rem;
      height: 1rem;
      margin: 0 4.5rem;
    }
  }
`;

export const QuoteWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Wrapper = styled.div`
  overflow-x: hidden;
`;
